(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["../modules/profiles/forms/select-jobs/partials/view-jobs-layout.partial.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"isLoading")) {
output += " ";
if(env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"viewData")) > 0) {
output += " ";
frame = frame.push();
var t_3 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"viewData");
if(t_3) {t_3 = runtime.fromIterator(t_3);
var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("job", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += " <div class=\"job pointer\"> <label class=\"container\"> <span class=\"job-name ";
if(runtime.memberLookup((t_4),"selected")) {
output += " selected ";
;
}
output += "\"> ";
output += runtime.suppressValue(env.getFilter("userPosition").call(context, {"Position": runtime.memberLookup((t_4),"position"),"custom_position": runtime.memberLookup((t_4),"aliasPosition")}), env.opts.autoescape);
output += " </span> <span class=\"miles-away ";
if(runtime.memberLookup((t_4),"tooFar")) {
output += " too-far ";
;
}
output += "\"> ";
output += runtime.suppressValue(runtime.memberLookup((t_4),"distance"), env.opts.autoescape);
output += " </span> <input type=\"checkbox\" class=\"job-item-checkbox\" name=\"selected_jobs\" ";
if(runtime.memberLookup((t_4),"already_applied") || runtime.memberLookup((t_4),"ats_url") || !runtime.memberLookup((t_4),"is_available_for_bulk_apply")) {
output += " disabled=\"disabled\" ";
;
}
output += " ";
if(runtime.memberLookup((t_4),"selected")) {
output += " checked=\"checked\" ";
;
}
output += " id=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"id"), env.opts.autoescape);
output += "\"> <span class=\"checkmark\"></span> ";
if(runtime.memberLookup((t_4),"already_applied")) {
output += " <span class=\"applied-note\"> <span class=\"pipe-note\"> | </span> ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"translatedText")),"already_applied"), env.opts.autoescape);
output += " </span> ";
;
}
output += " ";
if(runtime.memberLookup((t_4),"ats_url")) {
output += " <span class=\"ats-note\"> <span class=\"pipe-note\"> | </span> ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"translatedText")),"apply_via_external_link_only"), env.opts.autoescape);
output += " </span> <a href=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"ats_url"), env.opts.autoescape);
output += "\" class=\"external-link\" target=\"_blank\"> <span class=\"open-text\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"translatedText")),"open"), env.opts.autoescape);
output += "</span> </a> <div class=\"tooltip-box\"> <i class=\"fa fa-external-link blue\"> <span class=\"tooltip-content\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"translatedText")),"open_job_link_details_in_external_tab"), env.opts.autoescape);
output += "</span> </i> </div> ";
;
}
output += " ";
if(!runtime.memberLookup((t_4),"is_available_for_bulk_apply")) {
output += " <span class=\"ats-note\"> ";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"translatedText")),"apply_via_job_post_only"), env.opts.autoescape);
output += " </span> <a href=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"applyLink"), env.opts.autoescape);
output += "\" class=\"external-link\" target=\"_blank\"> <span class=\"open-text\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"translatedText")),"open"), env.opts.autoescape);
output += "</span> </a> <div class=\"tooltip-box\"> <i class=\"fa fa-external-link blue\"> <span class=\"tooltip-content\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"translatedText")),"open_job_link_details_in_external_tab"), env.opts.autoescape);
output += "</span> </i> </div> ";
;
}
output += " </label> </div> ";
;
}
}
frame = frame.pop();
output += " ";
;
}
output += " ";
;
}
output += " ";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
